import React, { useState, useEffect } from 'react';
import { IoIosArrowBack, IoIosCloseCircleOutline } from 'react-icons/io';
import { IoNavigateOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { IoSearchOutline } from 'react-icons/io5';
import Spinner from 'react-bootstrap/Spinner';
import { fetchWithAuth } from './authService';
import { API_ENDPOINTS } from '../utils/constants';

const Location = () => {
  const [cityList, setCities] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const Navigate = useNavigate();

  useEffect(() => {
    const fetchcities = async () => {
      const token = localStorage.getItem('tringAuthToken');
      if (!token) {
        console.error('No auth token found');
        return;
      }

      try {
        const citiesdata = await fetchWithAuth(API_ENDPOINTS.VENUES_CITY, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!citiesdata.ok) throw new Error('Failed to fetch data');

        const data = await citiesdata.json();
        // console.log(data);
        setCities(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    fetchcities();
  }, []);

  function goBack() {
    window.history.back();
  }

  function selectCity(city, coordinates) {
    localStorage.setItem('selectedCity', city);
    localStorage.setItem('latitude', coordinates[1]);
    localStorage.setItem('longitude', coordinates[0]);
    // console.log("Selected coordinates:", coordinates);
    Navigate('/main');
  }

  async function getLocation() {
    setIsLoading(true);
    const token = localStorage.getItem('tringAuthToken');

    if (!token) {
      console.error('No auth token found');
      setIsLoading(false);
      return;
    }

    // Check if geolocation is supported
    if (!navigator.geolocation) {
      alert('Geolocation is not supported by this browser.');
      setIsLoading(false);
      return;
    }

    // Check if we're in a secure context (HTTPS)
    if (!window.isSecureContext) {
      alert('Location access requires a secure connection (HTTPS)');
      setIsLoading(false);
      return;
    }

    try {
      // First check permission state
      const permission = await navigator.permissions.query({
        name: 'geolocation',
      });
      console.log('Geolocation permission:', permission.state);

      if (permission.state === 'denied') {
        alert(
          'Location access is blocked. Please enable location permissions in your browser settings.'
        );
        setIsLoading(false);
        return;
      }

      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: 10000, // 10 seconds timeout
          maximumAge: 300000, // 5 minutes cache
        });
      });

      const { latitude, longitude } = position.coords;

      const citiesdata = await fetchWithAuth(
        `${API_ENDPOINTS.VENUES_CITY}?isPopular=false&lat=${latitude}&lon=${longitude}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!citiesdata.ok) throw new Error('Failed to fetch data');

      const data = await citiesdata.json();

      localStorage.setItem('selectedCity', data?.currentCity?.city);
      localStorage.setItem('latitude', latitude);
      localStorage.setItem('longitude', longitude);
      setIsLoading(false);
      Navigate('/main');
    } catch (error) {
      setIsLoading(false);
      console.error('Error getting location:', error);

      // Provide specific error messages
      if (error.code === 1) {
        alert(
          'Location access denied. Please enable location permissions and try again.'
        );
      } else if (error.code === 2) {
        alert('Location unavailable. Please check your GPS/location settings.');
      } else if (error.code === 3) {
        alert('Location request timed out. Please try again.');
      } else {
        alert('Unable to detect location. Please select your city manually.');
      }
    }
  }

  const searchCities = async query => {
    if (!query) {
      setSearchResults([]);
      return;
    }

    setIsLoading(true);
    const token = localStorage.getItem('tringAuthToken');
    if (!token) {
      console.error('No auth token found');
      // setIsLoading(false);
      return;
    }

    try {
      const response = await fetchWithAuth(
        `${API_ENDPOINTS.VENUES_CITY}?search=${encodeURIComponent(
          query
        )}&isPopular=${false}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) throw new Error('Failed to fetch songs');

      const data = await response.json();
      setSearchResults(data?.cities); // assuming API responds with { songs: [...] }
      console.log(data);
    } catch (error) {
      console.error('Error fetching songs:', error);
    }
    setIsLoading(false);
  };

  return (
    <div
      className="px-2 my-0 py-0 d-flex flex-column align-items-center position-relative"
      style={{ height: '100dvh' }}
    >
      {isLoading ? (
        <div className="lmodale">
          <div className="loverlay"></div>

          <div className="lmodalecontent">
            <Spinner animation="border" role="status" style={{ color: 'red' }}>
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </div>
      ) : (
        <div></div>
      )}

      <div
        className="position-sticky w-100"
        style={{ top: 0, backgroundColor: '#FFF', zIndex: 1 }}
      >
        <div
          className="d-flex align-items-center justify-content-between mt-2"
          style={{ position: 'relative', height: '30px' }}
        >
          <IoIosArrowBack
            style={{
              fontSize: '20px',
              cursor: 'pointer',
              color: '#D0151C',
              zIndex: 1,
            }}
            onClick={goBack}
          />

          <span
            style={{
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              fontSize: 'clamp(0px,7dvw,20px)',
              background:
                'linear-gradient(100deg, #D61116 16.94%, #873662 83.06%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {localStorage.getItem('selectedCity')
              ? localStorage.getItem('selectedCity')
              : 'All Cities'}
          </span>
        </div>

        <div className="w-100 d-flex flex-column position-relative">
          <div
            className="d-flex flex-row align-items-center px-2 py-1 mt-1 w-100"
            style={{
              gap: '15px',
              borderRadius: '10px',
              border: '1px solid #C3C0C0',
              fontSize: '20px',
            }}
          >
            <IoSearchOutline className="mt-1" />
            <input
              type="text"
              style={{
                border: 'none',
                background: 'transparent',
                outline: 'none',
              }}
              placeholder="Search for a city..."
              className=" text-start"
              value={searchQuery}
              onChange={e => {
                const value = e.target.value;
                setSearchQuery(value);
                searchCities(value);
              }}
            />
          </div>
        </div>

        <div
          className="px-2 py-2 w-100 text-start my-2"
          style={{ border: 'solid 1px #C3C0C0', borderRadius: '10px' }}
          onClick={() => getLocation()}
        >
          <IoNavigateOutline style={{ color: '#D61116' }} className="" />
          <span
            className="common-txt mx-3"
            style={{
              background:
                'linear-gradient(100deg, #D61116 16.94%, #873662 83.06%)',
              backgroundClip: 'text',
              webkitBackgroundClip: 'text',
              webkitTextFillColor: 'transparent',
            }}
          >
            Detect My Location
          </span>
        </div>

        <h4
          className="w-100 text-start mt-3 mb-1 position-sticky"
          style={{ top: 0 }}
        >
          {searchResults.length === 0 && searchQuery.length === 0
            ? 'Popular Cities'
            : 'Search Results'}
        </h4>
      </div>

      <div
        className="w-100 d-flex flex-column position-relative"
        style={{ overflow: 'scroll', scrollBehavior: 'smooth', flexGrow: 1 }}
      >
        <div
          className="w-100"
          style={{ overflow: 'scroll', scrollBehavior: 'smooth', flexGrow: 1 }}
        >
          {searchResults?.length !== 0 || searchQuery.length !== 0 ? (
            <div
              className="w-100 mt-2"
              style={{ background: 'white', zIndex: 10 }}
            >
              {searchResults.map((cityobj, index) => (
                <div
                  key={index}
                  className="w-100 text-start"
                  onClick={() =>
                    selectCity(cityobj.city, cityobj.geometry.coordinates)
                  }
                >
                  <span>{cityobj?.city}</span>
                  <hr />
                </div>
              ))}
            </div>
          ) : (
            <div>
              {cityList.length === 0 ? (
                <div></div>
              ) : (
                <div>
                  {cityList.cities.map((city, index) => (
                    <div className="w-100 text-start my-2" key={index}>
                      <div
                        className="d-flex flex-row align-items-center my-2"
                        style={{ gap: '1dvh', color: '#C31925' }}
                        onClick={() =>
                          selectCity(city.city, city.geometry.coordinates)
                        }
                      >
                        <img
                          src={`images/${city.city}.svg`}
                          style={{
                            borderRadius: '50%',
                            width: 'clamp(0px,10dvw,50px)',
                            height: 'clamp(0px,10dvw,50px)',
                            color: '#C31925',
                          }}
                        />
                        <span style={{ color: 'black' }}>{city?.city}</span>
                      </div>

                      <hr />
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Location;
